import { ButtonField, ButtonFieldIcon, FileUploadField, Iconsvg, Pagination, PaginationBar, PaginationBarLeft, PaginationBarRight, Pill, SelectField } from '@wk/components-react16';
import React, { useEffect, useState } from 'react';
import HttpService from '../../config/http.service';
import { API_URL } from '../../config/constants/apiUrl';
import { Toast } from '../../services/Toast';

const MultiRunPrompt = () => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [promptStatuses, setPromptStatuses] = useState<any[]>([]);
    const [pagination, setPagination] = useState({ pageIndex: 1, pageSize: 10, pageCount: 0, totalCount: 0 });

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedFile(event.target.files?.[0] || null);
    };

    const removeFile = () => {
        setSelectedFile(null);
        const fileInput = document.getElementById('file-upload-prompt') as HTMLInputElement | null;
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const getPromptStatuses = (page: number = 1, size: number = 10) => {
        const payload = {
            pageNumber: page,
            pageSize: size,
        };

        HttpService.postRequest(API_URL.GET_MULTI_RUN_PROMPT_STATUS, payload).then(
            (response: any) => {
                const statuses = response.data || [];
                setPromptStatuses(statuses);
                setPagination({
                    pageIndex: page,
                    pageSize: size,
                    pageCount: Math.ceil((response.totalCount || 0) / size),
                    totalCount: response.totalCount || 0,
                });
            },
            (error: any) => { },
        );
    };

    useEffect(() => {
        getPromptStatuses(pagination.pageIndex, pagination.pageSize);
        const intervalId = window.setInterval(() => {
            getPromptStatuses(pagination.pageIndex, pagination.pageSize);
        }, 10000);

        return () => window.clearInterval(intervalId);
    }, [pagination.pageIndex, pagination.pageSize]);

    const pageChange = (page: number) => {
        getPromptStatuses(page, pagination.pageSize);
    };

    const onPageSizeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        getPromptStatuses(1, Number(event.target.value));
    };

    const getTopItem = () => 1 + pagination.pageSize * (pagination.pageIndex - 1);
    const runPrompts = () => {
        if (!selectedFile) {
            Toast('Please upload a prompt Excel file', 'error');
            return;
        }
        const formData = new FormData();
        formData.append('file', selectedFile);
        HttpService.postRequestFormData(API_URL.MULTI_RUN_PROMPT, formData).then(
            () => {
                Toast('Prompts submitted successfully', 'success');
                removeFile();
                getPromptStatuses(1, pagination.pageSize);
            },
            (error: any) => Toast(error.message || 'Failed to run prompts', 'error'),
        );
    };

    const downloadSampleExcel = () => {
        HttpService.getRequestBlob(
            API_URL.DOWNLOAD_MULTI_RUN_PROMPT_SAMPLE_FORMAT
        ).then(
            (response: any) => {
                const blob = response instanceof Blob
                    ? response
                    : response?.data;

                if (!blob || blob.size === 0) {
                    Toast('Downloaded sample format is empty', 'error');
                    return;
                }
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'BPR_Sample_Format.xlsx';
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            },
            (error: any) => {
                Toast(
                    error?.message || 'Failed to download sample format',
                    'error'
                );
            }
        );
    }
    const downloadResult = (id: number) => {
        HttpService.getRequestBlob(
            `${API_URL.DOWNLOAD_MULTI_RUN_PROMPT_RESULT}/${id}`
        ).then(
            (response: any) => {
                const blob = response instanceof Blob
                    ? response
                    : response.data;
                if (!blob || blob.size === 0) {
                    Toast('Downloaded file is empty', 'error');
                    return;
                }
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `MRP_Result_${id}.xlsx`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            },
            (error: any) => {
                Toast(
                    error?.message || 'Failed to download result',
                    'error'
                );
            }
        );
    };
    return (
        <>
            <div className='pt-10 pl-20 pr-20 pb-10'>
                <div className="wk-row mb-15">
                    <div className="wk-col-12">
                        <h4>Bulk Prompt Run</h4>
                    </div>
                </div>
                <div className="wk-row">
                    <div className="wk-col-12 flex">
                        <label htmlFor="file-upload-prompt" className="mr-10">Upload Prompt Excel : </label>
                        <FileUploadField
                            // label="Upload Prompt Excel"
                            labelFor="file-upload-prompt"
                        >
                            <input
                                id="file-upload-prompt"
                                type="file"
                                name="file-upload"
                                accept=".xlsx"
                                onChange={handleFileChange}
                            />
                        </FileUploadField>
                        {selectedFile && (
                            <Pill onUserRequest={removeFile}>
                                <span>{selectedFile.name}</span>
                                <Iconsvg name="close" isFill />
                            </Pill>
                        )}
                        <ButtonField size={'small'}>
                            <button type="button" className='ml-10' disabled={!selectedFile} onClick={runPrompts}>Run Prompts</button>
                        </ButtonField>
                        <ButtonField iconPosition="left" mode="text">
                            <button type="button" onClick={downloadSampleExcel}>
                                <Iconsvg name="download-line" />
                                Download Sample Excel
                            </button>
                        </ButtonField>
                    </div>

                </div>
                <div>
                    <table className="wk-table wk-table-bordered wk-table-small h-100">
                        <thead>
                            <tr>
                                <th>Excel name</th>
                                <th>User</th>
                                <th style={{ width: '300px' }}>Processing status</th>
                                <th style={{ width: '150px' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {promptStatuses.length > 0 ? promptStatuses.map((promptStatus: any, index: number) => (
                                <tr key={promptStatus.id || index}>
                                    <td>{promptStatus.name || '-'}</td>
                                    <td>{promptStatus.createdBy || '-'}</td>
                                    <td>{promptStatus.processingStatus || '-'}</td>
                                    <td>
                                        {(promptStatus.processingStatus === 'COMPLETED' ||
                                            promptStatus.processingStatus === 'FAILED') && (
                                                <ButtonFieldIcon>
                                                    <button type="button" onClick={() => downloadResult(promptStatus.id)} title="Download Result">
                                                        <Iconsvg name="download-line"></Iconsvg>
                                                    </button>
                                                </ButtonFieldIcon>
                                            )}
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'center' }}>No prompt statuses found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {promptStatuses.length > 0 && (
                        <PaginationBar>
                            <PaginationBarLeft>
                                {getTopItem()} - {Math.min(pagination.pageSize * pagination.pageIndex, pagination.totalCount)} of{' '}
                                {pagination.totalCount} results
                            </PaginationBarLeft>
                            <PaginationBarRight>
                                <SelectField size="small">
                                    <select onChange={onPageSizeChange} value={pagination.pageSize}>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </SelectField>
                                <Pagination
                                    pageIndex={pagination.pageIndex}
                                    pageCount={pagination.pageCount}
                                    controlMode="controlled"
                                    onUserRequest={pageChange}
                                />
                            </PaginationBarRight>
                        </PaginationBar>
                    )}
                </div>
            </div>
        </>
    );
};

export default MultiRunPrompt;
